import { pastRelativeToDate } from '@sequencehq/utils'
import { FC } from 'react'
import Page from 'components/Page'
import { StickyPanelFrame } from 'components/Page/StickyPanelFrame'
import { UsageEventsMagicTable } from './UsageEventsMagicTable'
import { Outlet } from 'react-router-dom'
import { Button, IconPlus } from '@sequencehq/core-components'
import { ProtectedButton } from 'lib/rbac'
import { CreateUsageEventDrawer } from './modals/CreateUsageEvent'
import { Provider, useAtom } from 'jotai'
import { showAddNewUsageEventDrawerAtom } from './usageEvents.atoms'

export const timestampFilterOptions = [
  {
    label: '1 week ago',
    value: pastRelativeToDate(new Date(), { weeks: 1 })
  },
  {
    label: '1 month ago',
    value: pastRelativeToDate(new Date(), { months: 1 })
  },
  {
    label: '3 months ago',
    value: pastRelativeToDate(new Date(), { months: 3 })
  },
  {
    label: '6 months ago',
    value: pastRelativeToDate(new Date(), { months: 6 })
  }
]

const UsageEventsBase: FC = () => {
  const [showAddNewDrawer, setShowAddNewDrawer] = useAtom(
    showAddNewUsageEventDrawerAtom
  )

  return (
    <>
      <CreateUsageEventDrawer
        isOpen={showAddNewDrawer}
        onClose={() => setShowAddNewDrawer(false)}
      />
      <StickyPanelFrame>
        <Page
          title="Events"
          addNewConfig={{
            button: (
              <ProtectedButton permission="org.usage:create">
                <Button
                  variant="primary"
                  leadingIcon={<IconPlus color="inherit" />}
                  onClick={() => setShowAddNewDrawer(true)}
                  data-testid="TopNavigation.add-new"
                >
                  New usage event
                </Button>
              </ProtectedButton>
            )
          }}
          paddingBottom={0}
        >
          <UsageEventsMagicTable />
        </Page>
      </StickyPanelFrame>
      <Outlet />
    </>
  )
}

export const UsageEvents = () => {
  return (
    <Provider>
      <UsageEventsBase />
    </Provider>
  )
}
